import React from "react";
import { Button, Modal } from "react-bootstrap";
import "../Style.scss";

function Scores(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <h4 style={{ color: "#d60000", textAlign: "center" }}>Filing Complaints on SCORES</h4>
        <h5 style={{ color: "#3fb9ea", textAlign: "center" }}>Easy & Quick</h5>
        <ul className="list">
          <li className="list">Register on SCORES portal</li>
          <li className="list">
            Mandatory details for filing complaints on SCORES
          </li>
          <ul
            className="subLists"
            style={{
              display: "flex",
              listStyleType: "none",
              width: "100%",
              background: "transparent",
            }}
          >
            <li
              className="subList"
              style={{ padding: "3px 7px", background: "#808080", color: "#fff" }}
            >
              Name
            </li>
            <li
              className="subList"
              style={{ padding: "3px 7px", background: "#808080", color: "#fff" }}
            >
              PAN
            </li>
            <li
              className="subList"
              style={{ padding: "3px 7px", background: "#808080", color: "#fff" }}
            >
              Address
            </li>
            <li
              className="subList"
              style={{ padding: "3px 7px", background: "#808080", color: "#fff" }}
            >
              Mobile Number
            </li>
            <li
              className="subList"
              style={{ padding: "3px 7px", background: "#808080", color: "#fff" }}
            >
              E-mail ID
            </li>
          </ul>
          <p className="disc">
            <span style={{ fontWeight: "bold" }}>Benefits:</span>
          </p>
          <ul className="lists">
            <li className="list">Effective communication</li>
            <li className="list">Speedy redressal of the grievances</li>
          </ul>
        </ul>
        <p className="disc">
          <span style={{ fontWeight: "bold" }}>Note:</span> You may refer the
          website
        </p>
        <p className="disc">
          <a
            href="https://scores.sebi.gov.in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#3fb9ea" }}
          >
            https://scores.sebi.gov.in/
          </a>{" "}
          for more information.
        </p>
        <div className="btnContainer" style={{display: "flex", justifyContent: "center"}}>
          <Button onClick={props.onHide}  style={{background: "#3fb9ea", border: "0px"}}>Close</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function ScoreContainer() {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <Button
        className="scoreBtnFooter"
        onClick={() => setModalShow(true)}
        style={{
          padding: "3px 0",
          border: "none",
          background: "transparent",
          fontSize: "14px",
        }}
      >
        Scores
      </Button>
      <Scores show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default ScoreContainer;
